export default {"src":"/_next/static/media/ic_verified_badge.2c50736b.svg","height":14,"width":14};